// extracted by mini-css-extract-plugin
export default {"blockGood":"Good_blockGood__EkxDu","flyingImage":"Good_flyingImage__ING6Z","fly-to-basket":"Good_fly-to-basket__DeF52"};